import { useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { getData } from 'src/Utils';
import { getSearchParams } from '../getQueryParams';
export var useApartmentOptions = function (_a) {
    var buildingId = _a.buildingId, towerId = _a.towerId, resetApartmentsSelect = _a.resetApartmentsSelect;
    var isFirstRender = useRef(true);
    useEffect(function () {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (resetApartmentsSelect) {
            resetApartmentsSelect();
        }
    }, [buildingId, towerId]);
    var searchParams = getSearchParams({ tower: towerId });
    var _b = useQuery(['apartment-options', buildingId, towerId], function () {
        return getData("/buildings/" + buildingId + "/apartments/dropdown?" + searchParams);
    }, {
        refetchOnWindowFocus: false,
        enabled: typeof buildingId === 'number' && typeof towerId === 'number',
    }), data = _b.data, isLoading = _b.isLoading;
    var apartmentOptions = [];
    if (data === null || data === void 0 ? void 0 : data.apartments) {
        apartmentOptions = data.apartments.map(function (apartment) { return ({
            label: apartment.number.toString(),
            value: apartment.id,
        }); });
    }
    return { isLoading: isLoading, apartmentOptions: apartmentOptions };
};
